import { GENERAL_STORE } from '../GeneralStore'
import { UserRoleName } from 'models'
import { User, Api } from 'utilities'
import { LoginPayload, InviteUserPayload, SignUpPayload } from './types'
import { RootStore } from 'store/RootStore'
import { DASHBOARD_PAGE_STORE } from 'store/DashboardPageStore'

export const USER_STORE = 'USER_STORE'

export class UserStore {
  rootStore: RootStore

  constructor (rootStore: RootStore) {
    this.rootStore = rootStore
  }

  authenticateAndRedirect = (
    { tokenType, accessToken, userDetails }: any,
    redirectPath = '/'
  ) => {
    User.authenticate({ jwt: { tokenType, accessToken }, userDetails })

    this.rootStore[DASHBOARD_PAGE_STORE].onLogin()

    const isPersonEditOnly = (userDetails?.roles || [])
      .some((r: { name?: UserRoleName }) => r?.name === UserRoleName.PERSON_EDIT_ONLY)
    this.rootStore[GENERAL_STORE].push(
      isPersonEditOnly ? '/persons' : redirectPath
    )
  }

  requestLogin = (payload: LoginPayload): void => {
    const { setLoadingOn, handleApiError } = this.rootStore[GENERAL_STORE]

    setLoadingOn()

    Api
      .post('/login', payload, 'userApi')
      .then(this.authenticateAndRedirect)
      .catch(handleApiError)
  }

  socialLogin = (provider: string, token: string): void => {
    const { setLoadingOn, handleApiError } = this.rootStore[GENERAL_STORE]

    setLoadingOn()

    Api
      .post('/social-login', { provider, token, client: 'backoffice' }, 'userApi')
      .then(this.authenticateAndRedirect)
      .catch(handleApiError)
  }

  getGoogleAuthUrl = async (): Promise<{ url: string }> => {
    const { setLoadingOn, setLoadingOff, handleApiError } = this.rootStore[GENERAL_STORE]

    setLoadingOn()

    try {
      const data = await Api.get<{ url: string }>('/auth/google-url', 'userApi')
      setLoadingOff()
      return data
    } catch (error) {
      handleApiError(error)
      return null
    }
  }

  getMicrosoftAuthUrl = async (): Promise<{ url: string }> => {
    const { setLoadingOn, setLoadingOff, handleApiError } = this.rootStore[GENERAL_STORE]

    setLoadingOn()

    try {
      const data = await Api.get<{ url: string }>('/auth/microsoft-url', 'userApi')
      setLoadingOff()
      return data
    } catch (error) {
      handleApiError(error)
      return null
    }
  }

  getAppleAuthUrl = async (): Promise<{ url: string }> => {
    const { setLoadingOn, setLoadingOff, handleApiError } = this.rootStore[GENERAL_STORE]

    setLoadingOn()

    try {
      const data = await Api.get<{ url: string }>('/auth/apple-url', 'userApi')
      setLoadingOff()
      return data
    } catch (error) {
      handleApiError(error)
      return null
    }
  }

  requestPasswordReset = (email: string): void => {
    alert('TODO: handle reset password request' + email)
    // TODO: handle reset password request
  }

  invite = (payload: InviteUserPayload) => {
    const {
      setLoadingOn, showSuccess,
      push, handleApiError
    } = this.rootStore[GENERAL_STORE]

    setLoadingOn()

    Api
      .post('/user/invite', payload, 'userApi')
      .then(() => {
        // console.log('res', res);
        showSuccess('Invitation email has been sent!')
        push('/administration')
      })
      .catch(handleApiError)
  }

  signUp = ({ code, ...payload }: SignUpPayload) => {
    const { setLoadingOn, handleApiError } = this.rootStore[GENERAL_STORE]

    setLoadingOn()

    Api
      .post(`/code/${code}`, payload, 'userApi')
      .then(data => this.authenticateAndRedirect(data, '/user-management/my-profile'))
      .catch(handleApiError)
  }
}
